import { useCallback, useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { useDebounce } from 'react-use'
import { useAtomValue, useSetAtom } from 'jotai/react'

import { LoginStatus } from '@/constants/common'
import useSolana from '@/lib/solana/hooks/useSolana'
import { inviterAtom, loginStatusAtom } from '@/stores/services'

import useLoginWallet, { useToken } from './services/useLoginWallet'
import { useWallet } from './useWallet'

const useSignAndLogin = () => {
  const setLoginStatus = useSetAtom(loginStatusAtom)
  const { signMessage } = useSolana()
  const { disconnect } = useWallet()

  const { token, address } = useToken()
  const inviter = useAtomValue(inviterAtom)

  const [signatureMessage, setSignatureMessage] = useState('')
  const [signature, setSignature] = useState('')
  const [walletLoading, setWalletloading] = useState(false)

  const { isLoading: httpLoading } = useLoginWallet(
    signature,
    signatureMessage,
    inviter,
    () => {
      setSignatureMessage('')
      setSignature('')
    }
  )

  const loginLoading = useMemo(
    () => walletLoading || httpLoading,
    [httpLoading, walletLoading]
  )

  const signMessageWithLogin = useCallback(async () => {
    const message =
      'Welcome to XPump Portal.\n' +
      'Please sign this message to login XPump Portal.\n\n' +
      'Timestamp: ' +
      parseInt(new Date().getTime() / 1000 + '')

    return await signMessage(message, {
      onTimeOut: (errorMessage) => {
        toast.error(errorMessage)
        disconnect()
      },
      onError: (errorMessage) => {
        toast.error(errorMessage)
        disconnect()
      }
    })
  }, [disconnect, signMessage])

  const init = useCallback(async () => {
    if (!address || token) return

    setWalletloading(true)
    const resp = await signMessageWithLogin()
    setWalletloading(false)

    if (resp) {
      setSignature(resp.signature)
      setSignatureMessage(resp.signatureMessage)
      return resp
      // 设置成功后，useLoginWallet会自动执行
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address, token])

  useDebounce(
    () => {
      init()
    },
    500,
    [init]
  )

  useEffect(() => {
    // console.log('>>>>>> address: ', address)
    let loginStatus: LoginStatus = LoginStatus.LOGOUT
    if (address) loginStatus = LoginStatus.UNSIGNED
    if (token) loginStatus = LoginStatus.LOGIN

    setLoginStatus(loginStatus)
  }, [address, setLoginStatus, token])

  return {
    loginLoading,
    signMessageWithLogin: init
  }
}

export default useSignAndLogin
